/*!
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
const INJECTION_KEY_THEME = Symbol.for("nc:theme:enforced");
export {
  INJECTION_KEY_THEME as I
};
//# sourceMappingURL=constants-Bls5liKo.mjs.map
